import React, { useState, useEffect, useCallback } from 'react'
import { modalVariants } from '../../../utils/frame-motion-variants'
import { motion } from 'framer-motion'
import { PersonalTrainerPackageImages } from './PersonalTrainerPackageImages'
import { PersonalTrainerPackage } from './PersonalTrainerPackage'
import { FaPhone, FaWhatsapp, FaComment } from 'react-icons/fa'
import { useRouter } from 'next/router';
import { LoadingCover } from '../../commons/LoadingCover'
import { SystemError } from '../../error/SystemError'
import { downloadAbout } from '../../../api/user/profile-api'
import { CloseButton } from '../../commons/buttons/CloseButton'

export const PackageView = (props) => {
    const packageView = props.packageView
    const router = useRouter()

    const [ about, setAbout ] = useState(0)

    const [ isLoading, setIsLoading ] = useState(false)
    const [ isSystemError, setIsSystemError ] = useState(false)
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""}) 

    const ele = document.getElementsByClassName("ptr__children")[0];
    if(ele){
        ele.style.transform = null;
    }

    const getAbout = useCallback(async() => {        
        try {
            setAbout(await downloadAbout("", packageView.userId))
        } catch (error) {
            console.log(error);
            
        }
    }, [packageView])

    useEffect(() => {
        if(!packageView) return
        getAbout()
    }, [packageView, getAbout])

    const changeRoute = (path) =>{
        setIsLoading(true)

        router.push(path).then((response) => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        const ele = document.getElementsByClassName("ptr__children")[0];
        if(!ele) return
        ele.style.transform = null;
    },)

  return (
    <>
        <div className="fixed inset-0 z-30 flex justify-center items-center pt-2 pb-2 backdrop-blur-sm bg-black/10 overflow-y-auto">
            <motion.div className="m-1 max-w-xl w-full bg-white rounded-lg shadow max-h-[80vh] overflow-y-auto"
                variants={modalVariants}
                initial="initial"
                animate="animate"
                exit="exit"  
            >
                <div className="relative bg-white rounded-lg shadow ">
                    <div className="flex justify-between items-center py-4 px-6 rounded-t border-b sticky top-0 bg-white z-10">
                        <h3 className="text-lg font-semibold text-orange-600">
                            {packageView.title}
                        </h3>
                        <CloseButton/>
                    </div>
                    <div className="p-6">  
                        <div className='space-y-4'>
                                <div className='shadow pb-4'>
                                    <PersonalTrainerPackageImages listing={packageView}/>                                    
                                    <PersonalTrainerPackage listing={packageView} stringsUserId={""}/>
                                    <div className='text-sm text-center text-orange-600 py-2'>
                                        <button onClick={() => changeRoute("/profile/" + packageView.userId)} className="shadow-sm py-2 px-3">
                                            Service Provider Profile
                                        </button>
                                    </div>
                                    <div className='px-2 text-sm'>
                                        <div className='my-5'>
                                            {packageView.corporateInd === 'Y' ?
                                                <>
                                                    <label className="text-orange-600 font-bold text-base">Get this Package: </label>
                                                    <div className='my-2'>
                                                        <span className='text-gray-500 whitespace-pre-wrap leading-6'>Please contact us support@stringssg.com</span>                                                                                                                      
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    {/* {about.mobileNumber > 0 &&
                                                        <div className='right-0 m-auto z-10'>
                                                            <div className='space-x-3 my-3 text-center'>
                                                                <a type="button" className="text-sm px-3 py-2 shadow-lg bg-white text-orange-600 rounded-full" href={`tel://${about.countryTelCd}${about.mobileNumber}`}>
                                                                    <span className='flex justify-center items-center'>
                                                                        <FaPhone/>&nbsp;Call
                                                                    </span>
                                                                </a>
                                                                <a type="button" className="text-sm px-3 py-2 shadow-lg bg-white text-orange-600 rounded-full" href={`sms://${about.countryTelCd}${about.mobileNumber};?&body=Hi!%20I%20like%20your%20package%20listed%20on%20StringsSG%20and%20would%20be%20interested%20to%20know%20more%20about%20your%20service.%20Please%20contact%20me.`}
                                                                    onClick={()=>mobileAction("sms")}>
                                                                    <span className='flex justify-center items-center'>
                                                                        <FaComment/>&nbsp;SMS
                                                                    </span>
                                                                </a>	
                                                                <a type="button" className="text-sm px-3 py-2 shadow-lg bg-white text-orange-600 rounded-full" target="_blank" rel="noreferrer" 
                                                                    href={`https://wa.me/${about.countryTelCd?.substr(1)}${about.mobileNumber}?text=Hi!%20I%20like%20your%20package%20listed%20on%20StringsSG%20and%20would%20be%20interested%20to%20know%20more%20about%20your%20service.%20Please%20contact%20me.`}
                                                                    onClick={()=>mobileAction("whatsapp")}>
                                                                    <span className='flex justify-center items-center'>
                                                                        <FaWhatsapp/>&nbsp;Whatsapp
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </div>                        
                                                    }                     */}
                                                </>
                                            }
                                        </div>
                                        
                                    </div>
                                </div>
                        </div>
                        {(packageView.corporateInd != 'Y' && about.mobileNumber > 0) &&
                            <div className='right-0 m-auto z-10 sticky bottom-2'>
                                <div className='space-x-3 my-3 flex justify-center'>
                                    <a type="button" className="text-sm w-fit" href={`tel://${about.countryTelCd}${about.mobileNumber}`}>
                                        <span className='flex justify-center items-center px-3 py-2 shadow-lg bg-amber-50 text-orange-600 rounded-full'>
                                            <FaPhone/>&nbsp;Call
                                        </span>
                                    </a>
                                    <a type="button" className="text-sm w-fit" href={`sms://${about.countryTelCd}${about.mobileNumber};?&body=Hi!%20I%20like%20your%20package%20listed%20on%20StringsSG%20and%20would%20be%20interested%20to%20know%20more%20about%20your%20service.%20Please%20contact%20me.`}
                                        onClick={()=>mobileAction("sms")}>
                                        <span className='flex justify-center items-center px-3 py-2 shadow-lg bg-amber-50 text-orange-600 rounded-full'>
                                            <FaComment/>&nbsp;SMS
                                        </span>
                                    </a>	
                                    <a type="button" className="text-sm w-fit" target="_blank" rel="noreferrer" 
                                        href={`https://wa.me/${about.countryTelCd?.substr(1)}${about.mobileNumber}?text=Hi!%20I%20like%20your%20package%20listed%20on%20StringsSG%20and%20would%20be%20interested%20to%20know%20more%20about%20your%20service.%20Please%20contact%20me.`}
                                        onClick={()=>mobileAction("whatsapp")}>
                                        <span className='flex justify-center items-center px-3 py-2 shadow-lg bg-amber-50 text-orange-600 rounded-full'>
                                            <FaWhatsapp/>&nbsp;Whatsapp
                                        </span>
                                    </a>
                                </div>
                            </div>                        
                        }                                      
                    </div>
                </div>
            </motion.div>
        </div>
        {isLoading &&
            <LoadingCover/>
        }
        {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
    </>
  )
}
